export default "__VITE_ASSET__YVxNFDcX__"